import Header from "./Header";
import Main from "./Main";
import './App.css';

function App() {
  return (
    <div>
      <Header />
      <Main />
    </div>
  );
}

export default App;
